import React from "react";
import { Header, Icon } from "@tvg/design-system";
import { SuccessHeaderContainer } from "./styled-components";

interface ConfirmModalHeaderProps {
  title: string;
}

const ConfirmModalHeader = ({ title }: ConfirmModalHeaderProps) => (
  <SuccessHeaderContainer>
    <Icon name="success" size="s" mr="space-3" />
    <Header
      tag="h2"
      qaLabel="pages-header"
      fontFamily="bold"
      color="green.700"
      fontSize="l"
    >
      {title}
    </Header>
  </SuccessHeaderContainer>
);

export default ConfirmModalHeader;
